import * as React from 'react';
import { IconProps } from '../types';

const IcGreaterThan = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M4.624.95v1.616L17.023 7.7 4.624 15.633v1.617l15-8.965V7.113L4.624.95Zm0 17.8v1.5h15v-1.5h-15Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="m4.124.203 16 6.575V8.57l-16 9.562V15.36l11.822-7.564L4.124 2.9V.203Zm1 1.492v.537l12.975 5.372-12.975 8.303v.462l14-8.367v-.553l-14-5.754Zm-1 16.555h16v2.5h-16v-2.5Zm1 1v.5h14v-.5h-14Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcGreaterThan;
